import { AlertCircleIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

/**
 * A server error at the top of a form, dialog or table card. The message arrives translated (the
 * useMutation / useRpcErrorMessage map); the raw English message never reaches the page. `role=alert`
 * so a screen reader announces it when a save fails.
 */
export function FormError({
  message,
  onDismiss,
  className,
}: {
  message: string | null | undefined;
  onDismiss?: () => void;
  className?: string;
}) {
  const { t } = useTranslation();
  if (!message) return null;
  return (
    <div
      role="alert"
      className={cn(
        'flex flex-wrap items-start gap-x-3 gap-y-1 rounded-md border border-danger/40 bg-card px-4 py-3 text-sm text-danger',
        className,
      )}
    >
      <AlertCircleIcon className="mt-0.5 size-4 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1 basis-40">{message}</p>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="-my-3 -mr-2 inline-flex min-h-touch shrink-0 items-center whitespace-nowrap rounded-md px-2 text-sm font-medium text-ink-muted hover:text-ink-secondary"
        >
          {t('common.dismiss')}
        </button>
      )}
    </div>
  );
}
